module.exports = __webpack_public_path__ + "static/thpcdinosaur2-7f0b7a55f0371b8832d15093a869b280.jpeg";